import { captureSentryException } from './sentry';

const reportedProviders = new Set<string>();

/**
 * A context hook was called in a frame rendered without its provider. This can
 * happen transiently while the protected provider tree tears down/remounts
 * during auth-state transitions (e.g. returning from a backgrounded tab), so
 * callers degrade to a loading-shaped fallback value instead of throwing -
 * a throw here takes the entire app down to the root error boundary.
 *
 * Reported once per provider per session so genuine wiring bugs stay visible
 * in Sentry (and loudly in the console during development).
 */
export function reportMissingProvider(providerName: string) {
  if (__DEV__) {
    console.error(
      `[missing-provider] ${providerName} is missing: hook rendered outside its provider; using fallback value. ` +
        'If this is not a transient auth/route transition, check the provider tree.',
    );
  }

  if (reportedProviders.has(providerName)) {
    return;
  }

  reportedProviders.add(providerName);
  captureSentryException(
    new Error(`${providerName} is missing (recovered with fallback value)`),
    {
      boundary: 'context-fallback',
      provider: providerName,
    },
  );
}
